import { getApiClient } from '@plandi/common'
import { components } from '@plandi/common/src/generated'

export const questionsApi = {
  getQuestions: (locale: string, params?: components['schemas']['FaqParams']) =>
    getApiClient(locale)
      .get<{ data: components['schemas']['FaqQueries'] }>('v1/faq', { params })
      .then(({ data }) => data.data),

  createLike: (
    requestBody: components['schemas']['FaqRequest'],
    locale: string
  ) =>
    getApiClient(locale)
      .post('v1/faq/useful', requestBody)
      .then(({ data }) => data)
}
